export const ONE_CLICK_BASE_URL = 'https://1click.chaindefuser.com'

export const DEFAULT_SLIPPAGE_BPS = 50

export const DEFAULT_QUOTE_DEADLINE_MS = 30 * 60 * 1000
